<template>
  <div class="well">
    <div class="filter">
      <h2 class="filter-header">Disability</h2>
      <A11yDropdown
        :dropdown-props="{
          ref:'disability-dropdown',
          class: 'browse-disability-dropdown',
        }"
        :button-props="{
          class: 'btn btn-default dropdown-toggle ellipsis',
          'data-role': 'trigger',
          'aria-label': `Disability: ${disabilityLabel}`
        }"
        :dom-attributes="{
          role: 'listbox',
          'aria-label': `Disability: ${disabilityLabel}`
        }"
      >
        <template slot="button-contents">
          {{ disabilityLabel }} <i class="fa fa-caret-down" />
        </template>
        <template slot="dropdown-items">
          <li
            v-for="disabilityOpt in disabilityOptions"
            :key="disabilityOpt.value"
            role="option"
            @click="handleDisabilityClick(disabilityOpt)"
            :class="{
              'cursor-not-allowed': disabilityOpt.locked,
              'locks': !isPremium
            }"
          >
            <template v-if="disabilityOpt.locked">
              <LockedOption :label="disabilityOpt.label" />
            </template>
            <a
              v-else
              role="button"
              class="disability-option"
              :title="disabilityOpt.label">
              {{ disabilityOpt.label }}
            </a>
          </li>
        </template>
      </A11yDropdown>
    </div>
    <div class="filter">
      <h2 class="filter-header">Subjects</h2>
      <PresentLevelsSubjectCheckboxWrapper
        v-for="subject in subjectOptions"
        :key="subject.value"
        :label="subject.label"
        :input-id="subject.label"
      >
        <input
          type="checkbox"
          class="mdc-checkbox__native-control"
          v-model="selectedSubjects"
          :value="subject.value"
          :id="subject.label"
          @change="(event) => handleSubjectClick(event)"
        >
      </PresentLevelsSubjectCheckboxWrapper>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import A11yDropdown from '@/components/A11yDropdown'
import PresentLevelsSubjectCheckboxWrapper from '@/components/presentlevels/PresentLevelsSubjectCheckboxWrapper'
import RedundantRouteMixin from '@/components/RedundantRouteMixin.js'
import LockedOption from '@/components/LockedOption'

export default {
  name: 'ImpactOfDisabilityFilters',
  components: {
    A11yDropdown,
    PresentLevelsSubjectCheckboxWrapper,
    LockedOption
  },
  mixins: [RedundantRouteMixin],
  props: {
    disability: {
      type: String,
      default: ''
    },
    disabilityOptions: {
      type: Array,
      required: true
    },
    loadingOptions: {
      type: Boolean,
    },
    subjects: {
      type: Array,
      default: () => []
    },
    subjectOptions: {
      type: Array,
      required: true
    },
    changeRequiresConfirmation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedSubjects: this.subjects,
    }
  },
  computed: {
    ...mapGetters('user',['isPremium']),
    disabilityLabel() {
      if (this.disability) {
        return this.disabilityOptions.filter(elem => elem.value === this.disability)[0].label
      } else {
        return ''
      }
    }
  },
  methods: {
    handleDisabilityClick(newVal) {
      if (!newVal.locked) {
        if (this.changeRequiresConfirmation) {
          this.$emit('confirmupdate:disability', newVal.value)
        } else {
          this.$emit('update:disability', newVal.value)
        }
      }
    },
    handleSubjectClick(evt) {
      if (this.changeRequiresConfirmation) {
        evt.preventDefault();
        this.$emit('confirmupdate:subjects', evt.target.value)
      } else {
        this.$emit('update:subjects', this.selectedSubjects)
      }
    }
  },
  watch: {
    subjects: function() {
      this.selectedSubjects = this.subjects
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/variables.less';
.filter-header {
  font-size: 1rem;
  font-weight: 700;
  line-height: 20px;
  color: @gray;
  margin: 0 0 5px 0;
  padding: 5px 0;
  text-transform: uppercase;
}
.filter {
  padding-bottom: 20px;
}
label {
  font-weight: normal;
}
/deep/ .mdc-checkbox-container .mdc-checkbox-label .mdc-checkbox-label-text-container .mdc-checkbox-label-text-main {
  font-weight: normal;
  font-size: 1rem;
}
/deep/ .browse-disability-dropdown {
  width: 100%;
  word-wrap:normal;
}
/deep/ .dropdown-toggle {
  width: 100%;
  text-align: left;
}
/deep/ .fa-caret-down {
  position: absolute;
  top: 9px;
  right: 8px;
}
.locks .locked-option {
  padding: 3px 20px 3px 3px;
}
.locks a {
  padding-left: 35px;
}
.lock-icon {
  margin-left: 3px;
}
</style>